import { Facebook, Instagram, MessageCircle } from "lucide-react";
import { useLang } from "./LangContext";
import { scrollToId } from "../scroll";
import { useSettings, channelLink, branchChannelLink } from "./SettingsContext";

const ICONS = { Instagram, Facebook };

export default function Footer() {
  const { t } = useLang();
  const { settings } = useSettings();
  const f = t.footer;

  return (
    <footer className="footer" data-testid="footer">
      <div className="wrap">
        <div className="footer-top">
          <div className="footer-logo">
            <img src="/logo.png" alt="MDR Gaming House logo" data-testid="footer-logo" />
            <div>
              <p className="footer-tagline font-display">{f.brandLine}</p>
              <p className="footer-cities">
                {f.cities}
                <span aria-hidden="true"> — </span>
                {f.tagline}
              </p>
            </div>
          </div>
          <div>
            <p className="footer-nav-title">{f.navTitle}</p>
            <div className="footer-links">
              {t.nav.links.map((l) => (
                <button key={l.id} className="footer-link" data-testid={`footer-link-${l.id}`} onClick={() => scrollToId(l.id)}>
                  {l.label}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="footer-social-row">
          <div className="social-row">
            {f.socials.map((name) => {
              const Icon = ICONS[name] || Instagram;
              const link = channelLink(name.toLowerCase(), settings?.contact);
              const Social = link ? "a" : "span";
              return (
                <Social
                  key={name}
                  className={`social-ph${link ? " social-link" : ""}`}
                  href={link?.href}
                  target={link ? "_blank" : undefined}
                  rel={link ? "noopener noreferrer" : undefined}
                  title={link ? name : f.socialSoon}
                  aria-disabled={link ? undefined : true}
                  data-testid={`footer-social-${name.toLowerCase()}`}
                >
                  <Icon size={19} aria-hidden="true" />
                  <span className="sr-only">{link ? name : `${name} — ${f.socialSoon}`}</span>
                </Social>
              );
            })}
            {t.branches.items.map((branch) => {
              const link = branchChannelLink(branch.id, "whatsapp", settings?.contact);
              const Social = link ? "a" : "span";
              return (
                <Social key={branch.id} className="branch-whatsapp-link" href={link?.href}
                  target={link ? "_blank" : undefined} rel={link ? "noopener noreferrer" : undefined}
                  aria-disabled={link ? undefined : true} title={link ? `WhatsApp — ${branch.city}` : f.socialSoon}
                  data-testid={`footer-whatsapp-${branch.id}`}>
                  <MessageCircle size={18} aria-hidden="true" /> WhatsApp · {branch.city}
                  {!link && <span className="sr-only"> — {f.socialSoon}</span>}
                </Social>
              );
            })}
          </div>
        </div>

        <div className="footer-bottom">
          <span data-testid="footer-copyright">© {new Date().getFullYear()} MDR Gaming House. {f.rights}</span>
          <span>{f.tagline}</span>
        </div>
      </div>
    </footer>
  );
}
